import { isLocal } from "@/environment";

export default function staticUrl(suffix) {
	const prefix = isLocal ? "/" : "/Content/Client/";
	return prefix + suffix;
}
